/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSlider = {
  init: function($section) {

    window.PXUTheme.jsSlider = $.extend(this, window.PXUTheme.getSectionData($section));

    const self = this;

    if(this.mobile_slider){

      const carousel = $section[0].querySelector('.mobile-slider-enabled');

      let flkty;

      function manageFlickity() {
        const breakpoint = 799; // Set the breakpoint width
        
        if (window.innerWidth < breakpoint) {
          if (!carousel.classList.contains('flickity-enabled')) {
            flkty = new Flickity(carousel, {
              watchCSS: false,
              cellAlign: 'left',
              contain: true,
              pageDots: false,
              wrapAround: true,
              autoPlay: 3000,
              pauseAutoPlayOnHover: self.pauseAutoPlayOnHover,
              prevNextButtons: self.slider_buttons,
              arrowShape: { 
                x0: 10,
                x1: 60, y1: 50,
                x2: 70, y2: 40,
                x3: 30
              }
            });
          }
        } else {
          if (carousel.classList.contains('flickity-enabled')) {
            if (flkty) {
              flkty.destroy();
              flkty = null;
            }
          }
        }
      }

      manageFlickity();

      window.addEventListener('resize', manageFlickity);

      function debounce(func, wait) {
        let timeout;
        return function () {
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(this, arguments), wait);
        };
      }

      window.addEventListener('resize', debounce(manageFlickity, 250));
    }
  }
}

/******/ })()
;